<template>
  <div class="refresh-modal">
    <modal-title title="Update Sharedo" @close="$emit('close')" />
    <div v-if="supportsPublishing">
      <div class="form-group text-left">
        <radio-button
          v-model="saveStatus"
          value="draft"
          id="status-control-draft"
          name="status"
          label="Save as draft"
          hint="Saves the content block as a draft."
        />
        <radio-button
          v-if="canPublish"
          v-model="saveStatus"
          value="published"
          id="status-control-publish"
          name="status"
          label="Save and publish"
          hint="Saves the content block and publishes it."
        />
      </div>
      <div>
        <info v-if="saveStatus === 'draft'" class="mt-1">
          Your changes will not be visible in the add-in until the content block
          is published.
        </info>
        <danger v-if="saveStatus === 'published'" class="mt-1"
          >This will replace the content currently in sharedo with the content
          from this document.</danger
        >
      </div>
    </div>
    <div v-else>
      <div>
        <danger
          >This will replace the content currently in sharedo with the content
          from this document.</danger
        >
      </div>
      <div class="version-info">
        <p><strong>Latest Version:</strong> {{ $filters.long(latestVersion) }}</p>
      </div>
    </div>
    <div class="main-actions">
      <button type="button" class="btn btn-primary" @click="updateContent">
        Update sharedo
      </button>
    </div>
  </div>
</template>
<script>
import ModalTitle from "@/components/common/modal/ModalTitle.vue";
import Danger from "@/components/common/banners/Danger.vue";
import Info from "@/components/common/banners/Information.vue";
import documentModel from "@/mixins/documentModel";
import profile from "@/mixins/profile";
import { CONTENT_BLOCKS_PUBLISH } from "@/constants/permissions";

export default {
  components: { ModalTitle, Danger, Info },
  mixins: [documentModel, profile],
  props: {
    contentBlock: {
      required: true,
    },
  },
  data: function () {
    return {
      saveStatus: "draft",
    };
  },
  computed: {
    latestVersion: function () {
      return this.contentBlock.versionDate;
    },
    supportsPublishing: function () {
      return !!this.capabilities.contentBlockPublishing;
    },
    canPublish: function () {
      return this.hasPermission(CONTENT_BLOCKS_PUBLISH);
    },
  },
  methods: {
    updateContent: function () {
      if (this.supportsPublishing) {
        this.$emit("update-content", this.contentBlock, this.saveStatus);
      } else {
        this.$emit("update-content", this.contentBlock);
      }
    },
  },
  emits: ["update-content"],
};
</script>
<style lang="scss" scoped>
.version-info {
  font-size: 0.8rem;
  text-align: left;
}
.main-actions {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & > button {
    margin-top: 10px;
  }
}
</style>
